/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of conditional workflow rules.
 */
export enum LoginAccountRuleType {
    USER_DOES_NOT_BELONG_TO = 'UserDoesNotBelongTo',
    USER_BELONGS_TO = 'UserBelongsTo',
}
